/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Custom Add button
 */

import { Button as AntButton, Tooltip, ButtonProps } from 'antd';
import { Plus } from '@icon-park/react';

/**
 * Add
 */
const Add: React.FC<ButtonProps> = ({ title = 'Add', ...restProps }) => {
	const key = `add-btn-${restProps.disabled ? 'disabled' : 'enabled'}`;
	return (
		<Tooltip title={title}>
			<AntButton key={key} color='default' variant='filled' {...restProps}>
				<Plus />
			</AntButton>
		</Tooltip>
	);
};

export default Add;
